import { render, staticRenderFns } from "./PostponementCreateForm.vue?vue&type=template&id=40693580&"
import script from "./PostponementCreateForm.vue?vue&type=script&lang=ts&"
export * from "./PostponementCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports